import { mapDTO } from '@twistezo/ts-dto-mapper'
import { omit } from 'lodash'

import { Ability } from 'providers/casl'
import { fieldsToOmit } from 'providers/tanstack-query/utils'
import { EditSchema } from '../../../schemas/editSchema'
import { Variables } from './types'

export const toDTO = (from: EditSchema, ability: Ability) =>
  mapDTO<EditSchema, Variables>({ from }).transform((data: EditSchema) => {
    const { customCodeEnabled, id, name, overriddenByYieldbird, pubAdsServiceRefresh } = data
    const { codeAfter, codeBefore, comment } = { ...data.customCodeAttributes }

    const constantFields: Pick<
      Variables,
      | 'customCodeAttributes'
      | 'customCodeEnabled'
      | 'id'
      | 'name'
      | 'overriddenByYieldbird'
      | 'pubAdsServiceRefresh'
    > = {
      customCodeAttributes: data.customCodeEnabled
        ? {
            codeAfter: codeAfter || null,
            codeBefore: codeBefore || null,
            comment: comment || null,
          }
        : null,
      customCodeEnabled,
      id,
      name,
      pubAdsServiceRefresh,
    }

    const variableFields: Pick<Variables, 'overriddenByYieldbird'> = {
      overriddenByYieldbird,
    }

    return {
      ...constantFields,
      ...omit(
        variableFields,
        fieldsToOmit<Variables>({
          overriddenByYieldbird: ability.cannot('update', 'DomainField-overriddenByYieldbird'),
        }),
      ),
    }
  })
